/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

export enum MandatoryMessageTypeEnum {
    SAVE = 'SAVE',
    SAVE_AND_SEND = 'SAVE_AND_SEND',
    SEND = 'SEND',
    CREATE = 'CREATE',
    APPLY = 'APPLY',
    NUMERIC = 'NUMERIC'
}
